<div class="rides-page">

    <!-- Header -->
    <div class="rides-header">
        <div class="rides-header-left">
            <h2 class="rides-title">Rides</h2>
            <span class="rides-subtitle">
                <span>{{ activeCount() }} Active now</span>
            </span>
        </div>
        <div class="rides-header-actions">
            <!-- <a routerLink="/ride-verification" class="rides-photo-btn">
                <img src="assets/icons/camera-icon.svg" alt="" width="14" height="14" />
                Photo verification
            </a> -->
            <button class="rides-export-btn" (click)="exportRides()">
                <i class="fa-solid fa-arrow-up-from-bracket"></i> Export
            </button>
        </div>
    </div>

    <!-- Tabs -->
    <div class="rides-tabs">
        <button class="rides-tab rides-tab--sharing"
            [class.rides-tab--active]="activeTab() === 'RIDE_SHARING'"
            (click)="switchTab('RIDE_SHARING')">
            Sharing
            <span class="rides-tab-badge">{{ sharingCount() }}</span>
        </button>
        <button class="rides-tab rides-tab--rental"
            [class.rides-tab--active]="activeTab() === 'RIDE_RENTAL'"
            (click)="switchTab('RIDE_RENTAL')">
            Rental
            <span class="rides-tab-badge">{{ rentalCount() }}</span>
        </button>
        <button class="rides-tab rides-tab--reservation"
            [class.rides-tab--active]="activeTab() === 'RESERVATION'"
            (click)="switchTab('RESERVATION')">
            Reservation
            <span class="rides-tab-badge">{{ reservationCount() }}</span>
        </button>
    </div>

    <!-- Tab panels — kept alive to avoid re-fetching on tab switch -->
     @if (activeTab() === 'RIDE_SHARING') {
        <p-card>
            <app-sharing-rides-list />
        </p-card>
     }
     @if (activeTab() === 'RIDE_RENTAL') {
        <p-card>
            <app-rental-rides />
        </p-card>
     }
     @if (activeTab() === 'RESERVATION') {
        <p-card>
            <app-reservation-list />
        </p-card>
     }
    

</div>
